import { Mail, Phone, MapPin, Send } from "lucide-react";
import { CONTACT } from "../data/siteContent";
import { ChapterHeading, ScrollReveal } from "./shared";

const Contact = () => {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="py-24 md:py-36 px-6 md:px-12 bg-[#F4F4F4] border-t border-[#E5E5E5]"
        >
            <ChapterHeading index="04" title="Get In Touch" />

            <div className="mt-12 md:mt-16">
                <ScrollReveal>
                    <h2 className="font-heading uppercase font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-tight max-w-3xl">
                        Talk to us directly.
                        <br />
                        <span className="text-outline-copper">We reply the same day.</span>
                    </h2>
                </ScrollReveal>
                <ScrollReveal delay={0.12}>
                    <p className="mt-6 text-base md:text-lg text-[#595959] max-w-xl leading-relaxed">
                        Call, email or WhatsApp us with your sizes, quantities or drawings —
                        and we will get back with rates and delivery time.
                    </p>
                </ScrollReveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12">
                <ScrollReveal delay={0.1}>
                    <div data-testid="contact-direct-emails" className="h-full border border-[#D9D9D9] bg-[#FAFAFA] p-6">
                        <div className="flex items-center gap-3 text-copper">
                            <Mail size={18} />
                            <span className="text-xs uppercase tracking-[0.25em]">Email us</span>
                        </div>
                        <div className="mt-4 flex flex-col gap-2.5">
                            {CONTACT.emails.map((email) => (
                                <a
                                    key={email}
                                    data-testid={`contact-email-link-${email.split("@")[0]}`}
                                    href={`mailto:${email}`}
                                    className="text-base md:text-lg text-[#111111] hover:text-copper transition-colors duration-300 break-all"
                                >
                                    {email}
                                </a>
                            ))}
                        </div>
                    </div>
                </ScrollReveal>

                <ScrollReveal delay={0.18}>
                    <div data-testid="contact-direct-phones" className="h-full border border-[#D9D9D9] bg-[#FAFAFA] p-6">
                        <div className="flex items-center gap-3 text-copper">
                            <Phone size={18} />
                            <span className="text-xs uppercase tracking-[0.25em]">Call us</span>
                        </div>
                        <div className="mt-4 flex flex-col gap-2.5">
                            {CONTACT.phones.map((phone) => (
                                <a
                                    key={phone}
                                    data-testid={`contact-phone-link-${phone.slice(-4)}`}
                                    href={`tel:${phone.replace(/-/g, "")}`}
                                    className="text-base md:text-lg text-[#111111] hover:text-copper transition-colors duration-300"
                                >
                                    {phone}
                                </a>
                            ))}
                        </div>
                    </div>
                </ScrollReveal>

                <ScrollReveal delay={0.26}>
                    <div data-testid="contact-address-card" className="h-full border border-[#D9D9D9] bg-[#FAFAFA] p-6">
                        <div className="flex items-center gap-3 text-copper">
                            <MapPin size={18} />
                            <span className="text-xs uppercase tracking-[0.25em]">Visit us</span>
                        </div>
                        <p className="mt-4 text-base md:text-lg leading-relaxed text-[#111111]">
                            {CONTACT.address}
                        </p>
                        <a
                            data-testid="contact-directions-link"
                            href={CONTACT.mapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-copper hover:text-copper-dark transition-colors duration-300"
                        >
                            Get directions <Send size={12} className="-rotate-45" />
                        </a>
                    </div>
                </ScrollReveal>
            </div>

            <ScrollReveal delay={0.1} className="mt-14">
                <div data-testid="contact-map-block" className="relative border border-[#D9D9D9] bg-[#FAFAFA]">
                    <div className="flex items-center justify-between px-5 py-4 border-b border-[#D9D9D9]">
                        <span className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-copper">
                            <MapPin size={14} />
                            Find our workshop
                        </span>
                        <a
                            data-testid="contact-map-open-link"
                            href={CONTACT.mapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[11px] uppercase tracking-[0.2em] text-[#737373] hover:text-copper transition-colors duration-300"
                        >
                            Open in Google Maps
                        </a>
                    </div>
                    <iframe
                        data-testid="contact-map-embed"
                        title="First Choice Trading Company — Gurunanak Compound, Patel Marg, Ghaziabad"
                        src={CONTACT.mapsEmbed}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                        className="w-full h-[320px] md:h-[420px] block grayscale contrast-[0.92]"
                    />
                </div>
            </ScrollReveal>
        </section>
    );
};

export default Contact;
